import { environment as e } from '../../environments/environment';

export const environment = e;
